/**
 * @ngdoc service
 * @name reserveDeviceTokenService
 * @description
 * get NRS Encrypt Data for post to SalesForce iFrame
 *
 * */


(function () {
  'use strict';

  angular
    .module('eclipseApp.reserveDevice')
    .factory('uteReserveDeviceNRSDataService', _service);

  _service.$inject = ['httpService'];

  /* @ngInject */
  function _service(httpService) {

    var Service = {
      getEncryptNRSData: getEncryptNRSData
    };

    return Service;

    function getEncryptNRSData(request, callback) {
      var _result = {};
      httpService.send('v1/nrs', request).then(
        function (data) {

          if (data) {
            _result.result = 'success';
            _result.data = data;
            return callback(_result);
          } else {
            _result.result = 'fail';
            _result.data = data;
            return callback(_result);
          }
        }, function (error) {
          // Error handling - 555 exception
          if (error.data.status === 555) {
            _result.result = 'error';
            _result.data = error;
            //_result.message = resource.get(error.error.errorCode);
            return callback(_result);

          } else {
            // anything but status code 555
            _result.result = 'error';
            _result.data = error;
            //_result.message = resource.get('maintenance_info');//TODO need error message define here
            return callback(_result);
          }
        }
      );
    }
  }

})();
